import {
  type LoginRequest,
  AuthenticationTokens,
} from '@applied/proto/web_services/candidate_experience/proto/authentication_pb';
import type { MessageType } from '@protobuf-ts/runtime/build/types/message-type';
import { postData } from 'api/http_requests';

const authenticationTokensType = AuthenticationTokens as MessageType<AuthenticationTokens>;

export type LoginResponse = {
  authenticationTokens: AuthenticationTokens;
  redirectURL: string;
};

/**
 * A request to submit credentials for login.
 *
 * @param username
 * @param password
 * @returns The authentication tokens for the user.
 * @throws If the credentials are not valid.
 */
export async function postLogin(username: string, password: string): Promise<LoginResponse | null> {
  const payload: LoginRequest = {
    username,
    password,
  };
  const response = await postData(`/api/login/`, payload);
  const location = response.headers.get('Location');
  if (!location) {
    throw new Error('Location header not found');
  }
  if (response.jsonPayload === null) {
    throw new Error('Response payload is null');
  }
  return {
    authenticationTokens: authenticationTokensType.fromJson(response.jsonPayload),
    redirectURL: location,
  };
}
